var MandateFlowPresenter = /** @class */ (function () {
    function MandateFlowPresenter(usecase) {
        this.usecase = usecase;
    }
    MandateFlowPresenter.prototype.uploadMandateImg = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.uploadMandate.execute({
                onSuccess: function (data) { return resolve(data.data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.createMandate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.createMandate.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.getMfBankDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfBankDetails.execute({
                onSuccess: function (data) { return resolve(data.data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.getMfNewBankDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfNewBankDetails.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.getMfMandate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfMandate.execute({
                onSuccess: function (data) {
                    resolve(data.data);
                },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.getMfMandateList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfMandateList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.downloadMandate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.downloadMandate.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.mandateSwitch = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mandateSwitch.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, null);
        });
    };
    MandateFlowPresenter.prototype.getEmandateUrl = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getEmandateUrl.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    MandateFlowPresenter.prototype.mandateTimeline = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mandateTimeline.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    return MandateFlowPresenter;
}());
export default MandateFlowPresenter;
